import * as React from "react";
import IconSmall from "../../../../hiberUiKit/src/atoms/Icon/IconSmall";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import "./expand.scss"
import classNames = require("classnames");

interface IState {
	isOpen: boolean;
	isHover: boolean;
}

interface IProps {
	isOpen?: boolean;
	onChange?: (isOpen: boolean) => void;
}

export default class Expand extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {isHover: false, isOpen: !!props.isOpen};
	}

	render() {
		const classes = classNames({
			"c-expander": true,
			"c-hover": this.state.isHover
		});
		const childClasses = classNames({
			"c-expander_props-childs": true,
			"is-open": this.state.isOpen
		});
		return (
			<div className={classes}>
				<div className={"c-expander_button"}
					 onMouseOver={() => this.setState({isHover: true})}
					 onMouseLeave={() => this.setState({isHover: false})}
					 onClick={() => this.setState({isOpen: !this.state.isOpen},
						 () => this.props.onChange && this.props.onChange(this.state.isOpen))}>
					<IconSmall icon={Icon.Filter} variant="burgundy" />
					<div>{this.state.isOpen ? "Hide filter options" : "Show filter options"}</div>
				</div>
				<div className={childClasses}>
					{this.props.children}
				</div>
			</div>
		)
	}
}